import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { Plus, X } from 'lucide-react';

const AddOrganizationModal = ({ isOpen, onClose, newOrganization, setNewOrganization, onAddOrganization }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-2xl" style={{ zIndex: 1000 }}>
                <DialogHeader>
                    <DialogTitle>Add New Organization</DialogTitle>
                    <DialogDescription>
                        Add a new organization and its contacts manually
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    <div>
                        <Label className='mb-3' htmlFor="org-name">Organization Name</Label>
                        <Input
                            id="org-name"
                            value={newOrganization.name}
                            onChange={(e) => setNewOrganization(prev => ({ ...prev, name: e.target.value }))}
                            placeholder="Enter organization name"
                        />
                    </div>

                    <div>
                        <div className="flex justify-between items-center mb-3">
                            <Label>Contacts</Label>
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={() => setNewOrganization(prev => ({
                                    ...prev,
                                    contacts: [...prev.contacts, { full_name: '', email: '', phone: '', title: '' }]
                                }))}
                            >
                                <Plus className="mr-2 h-4 w-4" />
                                Add Contact
                            </Button>
                        </div>

                        <div className="space-y-3 max-h-[300px] overflow-y-auto custom-scrollbar">
                            {newOrganization.contacts.map((contact, index) => (
                                <Card key={index} className="p-3">
                                    <div className="flex justify-between items-start mb-3">
                                        <h5 className="font-medium">Contact {index + 1}</h5>
                                        {newOrganization.contacts.length > 1 && (
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => setNewOrganization(prev => ({
                                                    ...prev,
                                                    contacts: prev.contacts.filter((_, i) => i !== index)
                                                }))}
                                            >
                                                <X className="h-4 w-4" />
                                            </Button>
                                        )}
                                    </div>
                                    <div className="grid grid-cols-2 gap-3">
                                        <div>
                                            <Label className="text-xs mb-3">Name</Label>
                                            <Input
                                                value={contact.full_name}
                                                onChange={(e) => {
                                                    const updated = [...newOrganization.contacts];
                                                    updated[index].full_name = e.target.value;
                                                    setNewOrganization(prev => ({ ...prev, contacts: updated }));
                                                }}
                                                placeholder="Contact name"
                                            />
                                        </div>
                                        <div>
                                            <Label className="text-xs mb-3">Title</Label>
                                            <Input
                                                value={contact.title}
                                                onChange={(e) => {
                                                    const updated = [...newOrganization.contacts];
                                                    updated[index].title = e.target.value;
                                                    setNewOrganization(prev => ({ ...prev, contacts: updated }));
                                                }}
                                                placeholder="Job title"
                                            />
                                        </div>
                                        <div>
                                            <Label className="text-xs mb-3">Email</Label>
                                            <Input
                                                type="email"
                                                value={contact.email}
                                                onChange={(e) => {
                                                    const updated = [...newOrganization.contacts];
                                                    updated[index].email = e.target.value;
                                                    setNewOrganization(prev => ({ ...prev, contacts: updated }));
                                                }}
                                                placeholder="email@example.com"
                                            />
                                        </div>
                                        <div>
                                            <Label  className="text-xs mb-3">Phone (Optional)</Label>
                                            <Input
                                                value={contact.phone}
                                                onChange={(e) => {
                                                    const updated = [...newOrganization.contacts];
                                                    updated[index].phone = e.target.value;
                                                    setNewOrganization(prev => ({ ...prev, contacts: updated }));
                                                }}
                                                placeholder="(555) 123-4567"
                                            />
                                        </div>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="flex justify-end space-x-2 pt-4">
                    <Button variant="outline" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={onAddOrganization}
                        disabled={
                            !newOrganization.name ||
                            !newOrganization.contacts.some(c => c.full_name?.trim() && c.email?.trim())
                        }
                    >
                        Add Organization
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AddOrganizationModal;